import React, { Component } from "react";
import _ from 'lodash';
import ReadOnlyScreen from './ReadOnlyScreen'
import {Modal} from 'react-bootstrap';
export default class DoubleScreen  extends Component {
  render(){
     let fieldValue = _.cloneDeep(this.props.object.Information)
     let title = fieldValue.Region.inventoryRegionName+' / '+fieldValue.Center.inventoryCenterName+' / '+
    fieldValue.Client.inventoryClientName+' / '+fieldValue.Process.inventoryProcessName   
     let auditorJson = {'templateValue':this.props.object.templateValue}
     let Additionalobj=[];
    if(!_.isEmpty(this.props.object.templateValue.Additional)){
      let x = this.props.object.templateValue.Additional;
      let val;
      
      _.map(x, (abc) =>{
        if(abc.label === 'Text Area'){
          val = abc.textAreaValues;
        } else if (abc.label === 'Text Box'){
          val = abc.textBoxValues;
        } else if (abc.label === 'Drop Down'){
            let cc = _.map(abc.selected, (o) =>{
              return  o.label
            })
            val = cc.toString()
        }
        Additionalobj.push({'label':abc.labelObj, 'value':val})
      })

    }

    let arrayobj=[];
    // delete fieldValue.auditFormWithoutFeedback
    // delete fieldValue.id
    arrayobj.push(      
      // {'label':'Region', 'value': fieldValue.Region.inventoryRegionName},
      // {'label':'Center', 'value': fieldValue.Center.inventoryCenterName},
      // {'label':'Client', 'value': fieldValue.Client.inventoryClientName},      
      // {'label':'Process', 'value': fieldValue.Process.inventoryProcessName},
      {'label':'Date', 'value': fieldValue['Date/Time']},          
      {'label':'Call Type', 'value': fieldValue.CallType},
      {'label':'Employee ID', 'value': fieldValue.employeeID},
      {'label':'Agent Name', 'value': fieldValue.Details.agentName},
      {'label':'Skill Set', 'value': fieldValue.Details.skillSetName},
      {'label':'Tenure', 'value': fieldValue.Details.tenure},
      {'label':'TL Name', 'value': fieldValue.Details.tlName},
       ...Additionalobj      
      )
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Compliance Form For -{title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body><ReadOnlyScreen auditorJson={auditorJson} 
      fieldValue = {arrayobj} 
      loginUserName={this.props.loginUserName}
      action={this.props.action} closeModal={this.props.closeModal} 
      ScoreCalculation={this.props.ScoreCalculation}
      /></Modal.Body>
      </Modal>

    )
  }
}